<template>
  <o-view>
    <o-nav-bar title="Infowizard Demo" />
    <o-info-wizard :slides="slides" />
  </o-view>
</template>

<script>
import OInfoWizard from '@/components/OInfoWizard.vue'
export default {
  name: 'InfoWizard',
  components: { OInfoWizard },
  data: () => ({
    slides: [
      'https://www.olympus-mobility.be/nl/contractuele-en-algemene-voorwaarden/',
      'https://www.olympus-mobility.be/nl/vaak-gestelde-vragen/',
      'https://www.olympus-mobility.be/nl/voor-partners/'
    ]
  })
}
</script>
